import { render } from "./xtx-checkbox.vue?vue&type=template&id=75fc0d1f&scoped=true"
import script from "./xtx-checkbox.vue?vue&type=script&lang=js"
export * from "./xtx-checkbox.vue?vue&type=script&lang=js"

import "./xtx-checkbox.vue?vue&type=style&index=0&id=75fc0d1f&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lhc\\hk-lottery-lhc-ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75fc0d1f"]])

export default __exports__